//main api call to get list
const getList = (url,params) => {

    return axios.get(url,{params});    
};

//get field list
const getFieldsList = (modulekey,studio,def,slug) => { 
    let params = {                        
        studio:studio,
        def:def
    };  
    let url = '/'+slug+'/fields/'+modulekey;   
    return getList(url,params);
};
const getInvFieldsList = (modulekey,studio,def,slug) => { 
    let params = {                        
        studio:studio,
        def:def
    };  
    let url = '/'+slug+'/fields/'+modulekey+'/inv-fields';   
    return getList(url,params);
};
//getLayout view
const getLayout = (modulekey,view,studio,slug) => {
    let url = '/'+slug+'/fields/getlayout/'+modulekey+"/"+view;
    let params = {                        
        studio:studio
    };
    return getList(url,params);
};

Object.size = function(obj) {
    var size = 0,
      key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++;
    }
    return size;
};

const objSize = (obj) =>
{
    return Object.size(obj);
}
//getLineItemLayout view
 const getLineItemLayout = (modulekey,studio,slug) => {
    let url = '/'+slug+'/fields/getLineItemList';
    let params = {                        
        studio:studio,
        module:modulekey, 
    };
    return getList(url,params);
};
//getLineItemLayoutdef
const getLineItemLayoutDef = (modulekey,field,studio) => {
    let url = '/builder/fields/getLineItemDef';
    let params = {                        
        studio:studio,
        field:field,
        module:modulekey, 
    };
    return getList(url,params);
};
const getLineItemFDef = (modulekey,field,studio) => {
    let url = '/builder/fields/getLineItemFDef';
    let params = {                        
        studio:studio,
        field:field,
        module:modulekey, 
    };
    return getList(url,params);
};
//getLineItemFieldList  TODO av sirf builder se call hoga ye method. studio ke liye v banana h
const getLineItemFieldList = (modulekey,studio) => {
    let url = '/builder/fields/getLineItemFieldList';
    let params = {                        
        studio:studio,        
        module:modulekey, 
    };
        //console.log("URL INVOICE", url);
    return getList(url,params);
};

//Invoice Item field getInvoiceFieldDef
const getInvoiceFieldDef = (modulekey,field,studio) => {
    let url = '/builder/fields/getInvoiceFieldDef';
    let params = {                        
        studio:studio,
        field:field,
        module:modulekey, 
    };
    //console.log("URL INVOICE", url);
    return getList(url,params);
};

const getInvoiceItemLayoutDef = (modulekey,field,studio) => {
    let url = '/builder/fields/getInvoiceItemLayoutDef';
    let params = {                        
        studio:studio,
        field:field,
        module:modulekey, 
    };
    console.log("URL INVOICE", url);
    return getList(url,params);
};


const setLayout = (modulekey,view,studio,data,slug) => {
    let url =  '/'+slug+'/fields/setlayout';
    let params = {                        
        module:modulekey,               
        studio:studio,
        data:data,
        view:view
    };
    return axios.post(url,params);
};

const setDeployLayout = (modulekey,view,studio,data,slug) => {
    let url =  '/'+slug+'/fields/setdeploylayout';
    let params = {                        
        module:modulekey,               
        studio:studio,
        data:data,
        view:view
    };
    return axios.post(url,params);
};





const getRelate = (modulekey,studio,slug) => {

    console.log("getRelate For LineItem modulekey",modulekey);
    console.log("getRelate For LineItem studio",studio);
    console.log("getRelate For LineItem slug",slug);

    let url = '/'+slug+'/module/relations/';
    let params = {
        module:modulekey,
        studio:studio,
    }
    return axios.get(url,{params});
}

const deleteList = (listId) => {}

export { getLineItemFieldList,getInvoiceFieldDef,getLineItemFDef, getList, getFieldsList,getInvFieldsList, getLayout ,setLayout, getRelate, objSize, getLineItemLayout, getLineItemLayoutDef ,setDeployLayout,getInvoiceItemLayoutDef}


//in next file
/* <script>
import { sendList, getLists, deleteList } from '../statics/functions.js'
...
created() { getLists() }, */